import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Avatar,
  Divider,
  Chip,
  Paper
} from "@mui/material";

import { decrypt } from "../../components/cryptoUtil";



function UserDetails() {
 const UserDetails = (JSON.parse(decrypt(localStorage.getItem('tokenData'))));

const roleMap = {
  1: "User",
  2: "SSO",
  3: "MIS User",
  9: "Admin",
  999: "Super Admin"
};

  const options = {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: true,
  timeZone: 'Asia/Kolkata'
};



const JoinningDate = new Date(UserDetails.accountcreationdate).toLocaleString('en-IN', options);
const LastLoginDate = new Date(UserDetails.lastlogintime).toLocaleString('en-IN', options);
const ValidityEndDate = new Date(UserDetails.validitytill).toLocaleString('en-IN', options);

// // const [location, setLocation] = useState(null);
// //   const [error, setError] = useState(null);

// //   const getLocation = () => {
// //     if (!navigator.geolocation) {
// //       setError("Geolocation is not supported by your browser.");
// //       return;
// //     }

//     navigator.geolocation.getCurrentPosition(
//       (position) => {
//         setLocation({
//           latitude: position.coords.latitude,
//           longitude: position.coords.longitude,
//         });
//         setError(null);
//       },
//       (err) => {
//         setError(err.message);
//         setLocation(null);
//       }
//     );
//   };
// Sample user data for demo
  const userData =  {
    name: UserDetails.userfullname,
    username: UserDetails.userId,
    email: UserDetails.email,
    phone: UserDetails.mobile,

   // location: location.latitude ? `Lat: ${location.latitude}, Lon: ${location.longitude}` : "Location not available"  ,

    joined: JoinningDate||'',
    lastlogin:LastLoginDate||'',
    role: roleMap[UserDetails.userrole],
    //avatar: "https://i.pravatar.cc/150?img=2",
  //  avatar: "https://sriaynsh.com/images/rib.png",
   

  };

  return (


    
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{
        backgroundColor: "#f5f7fa",
        minHeight: "100vh",
        p: 3,
      }}
    >
      <Card sx={{ maxWidth: 700, width: "100%", borderRadius: 4, boxShadow: 5 }}>
        <Box
          sx={{
            background:
              "linear-gradient(135deg, #42a5f5 0%, #478ed1 100%)",
            height: 180,
            position: "relative",
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
          }}
        >
          <Avatar
            src={userData.avatar}
            sx={{
              width: 120,
              height: 120,
              position: "absolute",
              bottom: -60,
              left: "50%",
              transform: "translateX(-50%)",
              border: "4px solid white",
            }}
          />
        </Box>
        <CardContent sx={{ mt: 7 }}>
          <Typography variant="h5" align="center" gutterBottom>
            {userData.name}
          </Typography>
          <Typography
            variant="subtitle1"
            align="center"
            color="text.secondary"
            gutterBottom
          >
            @{userData.username}
          </Typography>
          <Box display="flex" justifyContent="center" my={1}>
            <Chip label={"Your Role : " + userData.role} color="primary" />
          </Box>

          <Box display="flex" justifyContent="center" my={1}>
            <Chip label={UserDetails.sofwaredetailsname + ", " + UserDetails.address}   color="sucess" />
          </Box>
          
          <Divider sx={{ my: 2 }} />

          <Grid container spacing={2}>
            <Grid xs={12} sm={6}>
              <Paper sx={{ p: 2, display: "flex", alignItems: "center", gap: 1, }}>
             
                <Typography>📩 E-Mail : {userData.email}</Typography>
              </Paper>
            </Grid>
            <Grid xs={12} sm={6}>
              <Paper sx={{ p: 2, display: "flex", alignItems: "center", gap: 1 }}>
                 <Typography>📲 Mobile : {userData.phone}</Typography>
              </Paper>
            </Grid>
          
            <Grid xs={12} sm={6}>
              <Paper sx={{ p: 2, display: "flex", alignItems: "center", gap: 1 }}>
                
                <Typography>🗓️ Created: {userData.joined}</Typography>
              </Paper>
            </Grid>

             <Grid xs={12} sm={6}>
              <Paper sx={{ p: 2, display: "flex", alignItems: "center", gap: 1 }}>
               
                <Typography> 🚨  Last Login: {userData.lastlogin}</Typography>
              </Paper>
            </Grid>


         


           

          </Grid>

           <Box display="flex" justifyContent="center" my={1}>
  <Chip
    label={`🫷🥺🫸 Software Validity Till: ${ValidityEndDate} 🫷🥺🫸`}
    sx={{
      backgroundColor: "#f70707ff",
      color: "#fff", // text color (white for contrast)
      fontWeight: "bold"
    }}
  />
</Box>
        </CardContent>
      </Card>
    </Box>
  );
}


export default UserDetails